import React, { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import axios from "axios";

const DetailDataBPS = ({ formatDate }) => {
    const { tableId } = useParams();
    const location = useLocation();
    const [dataDetail, setDataDetail] = useState(location.state?.data || null);
    const [loading, setLoading] = useState(!location.state?.data);

    // Fungsi formatDate yang lebih aman
    const safeFormatDate = (dateString) => {
        if (!dateString) return "-";
        
        try {
            // Coba format tanggal dari API BPS (format mungkin berbeda)
            if (typeof dateString === 'string') {
                // Format tanggal dari BPS biasanya seperti '2023-12-31'
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    const months = [
                        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
                    ];
                    return `${parts[2]} ${months[parseInt(parts[1]) - 1]} ${parts[0]}`;
                }
                // Jika format tidak sesuai, kembalikan aslinya
                return dateString;
            }
            return "-";
        } catch (error) {
            console.error('Error formatting date:', error);
            return dateString || "-";
        }
    };

    useEffect(() => {
        if (!location.state?.data) {
            const fetchBPSDetail = async () => {
                setLoading(true);
                try {
                    const response = await axios.get(
                        `https://webapi.bps.go.id/v1/api/view/model/statictable/lang/ind/id/${tableId}/key/2a5fc573c8b3c000270a925dd7d8f334`
                    );
                    
                    if (response.data?.data?.[1]) {
                        const bpsData = response.data.data[1];
                        const formattedData = {
                            name: bpsData.table_id || tableId,
                            title: bpsData.title || 'Data BPS',
                            author: 'BPS Kabupaten Sampang',
                            metadata_modified: bpsData.updt_date || new Date().toISOString(),
                            subject: bpsData.subj || 'Statistik',
                            size: bpsData.size || '-',
                            excel_url: bpsData.excel || null,
                            source: 'BPS',
                            raw_data: bpsData
                        };
                        setDataDetail(formattedData);
                    }
                } catch (error) {
                    console.error('Error fetching BPS detail:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchBPSDetail();
        }
    }, [tableId, location.state]);

    const handleDownload = () => {
        if (dataDetail?.excel_url) {
            const link = document.createElement('a');
            link.href = dataDetail.excel_url;
            link.setAttribute('download', `${dataDetail.title || 'bps_data'}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <section className="d-flex align-items-center" style={{ marginTop: '60px' }}>
            <div className="container" data-aos="fade-in">
                <div className="row content" data-aos="fade-in">
                    <Link to={`/open_data/kumpulan_data`} className="breadcrumb">
                        <i className="bx bx-arrow-back"></i> Kembali
                    </Link>
                </div>
                {loading ? (
                    <div className="col-md-12 text-center">
                        <h4>Loading Data...</h4>
                    </div>
                ) : dataDetail ? (
                    <div className="row content">
                        <div className="col-md-12 m-b-20">
                            <p className="author">
                                <i className="bx bx-user-circle"></i> {dataDetail.author} | 
                                <i className="bx bx-time"></i> {safeFormatDate(dataDetail.metadata_modified)}
                            </p>
                            <h4 className="m-b-10 font-weight-600">
                                {dataDetail.title}
                            </h4>
                            <p className="content">
                                {dataDetail.subject || 'Data statistik dari BPS Kabupaten Sampang'}
                            </p>
                        </div>

                        <div className="col-md-6">
                            <div className="box-additional">
                                <div className="header-additional">
                                    <i className="bx bx-info-circle"></i> Informasi Tambahan
                                </div>
                                <div>
                                    <table className="table table-striped-columns m-b-0">
                                        <tbody>
                                            <tr>
                                                <td className="font-weight-100">Sumber</td>
                                                <td>BPS Kabupaten Sampang</td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-100">Kategori</td>
                                                <td>{dataDetail.subject || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-100">Ukuran File</td>
                                                <td>{dataDetail.size || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-100">Terakhir Diupdate</td>
                                                <td>{safeFormatDate(dataDetail.metadata_modified)}</td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-100">ID Tabel</td>
                                                <td>{dataDetail.name || '-'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="box-additional">
                                <div className="header-additional">
                                    <i className="bx bx-data"></i> Data dan Resources
                                </div>
                                <div className="p-10 box-additional-body">
                                    {dataDetail.excel_url ? (
                                        <div 
                                            className="box-file" 
                                            onClick={handleDownload}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="box-format">
                                                <i className="bx bxs-file-excel"></i>
                                            </div>
                                            <div className="m-l-10">
                                                {dataDetail.title || 'Data BPS'}
                                                <p style={{ fontSize: '12px', color: '#a2a2a2' }}>
                                                    <i className="bx bx-time"></i> {safeFormatDate(dataDetail.metadata_modified)}
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="box-file">
                                            <div className="box-format">
                                                <i className="bx bxs-file"></i>
                                            </div>
                                            <div className="m-l-10">
                                                Data tidak tersedia untuk diunduh
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="col-md-12 text-center">
                        <h4>Data tidak ditemukan</h4>
                    </div>
                )}
            </div>
        </section>
    );
};

export default DetailDataBPS;